export default "__VITE_ASSET__BTFo0VJY__"